import React, { useState, useEffect, useContext } from "react";
import { Table } from "flowbite-react";
import { FaArrowRightLong } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context";
import Loader from "../Loader/Loader";

const CoinsInTray = () => {

    const navigate = useNavigate();

    const { state } = useContext(UserContext);

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;


    const [rows, setRows] = useState([
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 2, total: 0 },
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 1, total: 0 },
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 0.5, total: 0 },
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 0.2, total: 0 },
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 0.1, total: 0 },
        { balanceType: 'coinsintray', looseQuantity: 0, bulkQuantity: 0, denomination: 0.05, total: 0 },
    ]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const getBalance = async () => {
        setIsLoading(true)
        const balance = await axios.get(process.env.REACT_APP_API_URL + 'getLocalCurrencyBalance', {
            params: { balanceType: 'coinsintray', shopId: userDetail?.shopId },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (balance.data.length) {
            setRows(balance.data);
        }
        setIsLoading(false);
    }
    useEffect(() => {
        getBalance();
    }, []);

    // Calculate grand total on initial render and update state
    useEffect(() => {
        const initialTotal = rows.reduce((acc, row) => acc + row.total, 0);
        setGrandTotal(initialTotal);
    }, [rows]);

    const handleInputChange = (index, inputIndex, value) => {
        setRows((prevRows) =>
            prevRows.map((row, rowId) => {
                if (rowId === index) {
                    const updatedRow = { ...row, [`${inputIndex}`]: value };
                    let bulkMultiplier;
                    switch (updatedRow.denomination) {
                        case 2:
                            bulkMultiplier = 25;
                            break;
                        case 1:
                        case 0.5:
                        case 0.2:
                            bulkMultiplier = 20;
                            break;
                        case 0.1:
                        case 0.05:
                            bulkMultiplier = 40;
                            break;
                        default:
                            bulkMultiplier = 10;
                    }
                    // Calculate total
                    updatedRow.total =
                        updatedRow.looseQuantity * updatedRow.denomination +
                        updatedRow.bulkQuantity * bulkMultiplier * updatedRow.denomination;

                    // Re-calculate grand total based on the updated row
                    const newGrandTotal = prevRows
                        .map((row) => row === updatedRow ? updatedRow.total : row.total)
                        .reduce((acc, row) => acc + row, 0);

                    setGrandTotal(newGrandTotal);

                    return updatedRow;
                } else {
                    return row;
                }
            })
        );
    };

    const handleUpdate = async (req, res) => {
        try {
            setIsLoading(true)
            await axios.post(`${process.env.REACT_APP_API_URL}/updateLocalCurrencyBalance`, rows, {
                params: {
                    shopId: userDetail?.shopId
                },
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Success: Balance updated.');
            navigate("/local-currency-balance");
            setIsLoading(false)
        } catch (error) {
            console.error('Error updating balance:', error);
            toast.error('Error: Balance not updated.');
            setIsLoading(false)
        }
    };

    return (
        <div className="">
            {isLoading? <Loader />: ''}
            <div className="">
                {/* <h1 className="text-headings text-3xl font-medium mt-10">Local Currency Balance - Coins in Tray</h1> */}
            </div>
            <div className="overflow-x-auto mt-12">
                <div className="flex justify-end px-5 pb-5">
                    <span className="text-lg align-middle font-medium mr-5">Total:</span>
                    <div className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-4 py-3 text-lg">{grandTotal.toFixed(2)}/-</div>
                </div>
                <Table>
                    <Table.Head>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Sr #</Table.HeadCell>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Balance Inquiry</Table.HeadCell>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Loose Quantity</Table.HeadCell>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Bulk Quantity</Table.HeadCell>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Denomination</Table.HeadCell>
                        <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Total</Table.HeadCell>
                    </Table.Head>
                    <Table.Body>
                        {rows.map((row, index) => (
                            <Table.Row key={index}>
                                <Table.Cell>
                                    {index + 1}
                                </Table.Cell>
                                <Table.Cell className="flex">
                                    AUD <FaArrowRightLong className="mx-1 mt-1" /> Australian Dollar
                                </Table.Cell>
                                <Table.Cell>
                                    <input
                                        type="number"
                                        onChange={(e) => e.target.value >= 0 && handleInputChange(index, 'looseQuantity', e.target.value)}
                                        value={row.looseQuantity}
                                    />
                                </Table.Cell>
                                <Table.Cell>
                                    <input
                                        type="number"
                                        value={row.bulkQuantity}
                                        onChange={(e) => e.target.value >= 0 && handleInputChange(index, 'bulkQuantity', e.target.value)}
                                    />
                                </Table.Cell>
                                <Table.Cell>{row.denomination < 1 ? row.denomination * 100 : row.denomination} {row.denomination < 1 ? 'c' : '$'}</Table.Cell>
                                <Table.Cell>{row.total.toFixed(2)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
                <button className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-4 py-3 text-lg mt-4" onClick={handleUpdate}>Update Balance</button>
            </div>
        </div>
    )
}

export default CoinsInTray;